import React from 'react'
import NoDataFound from '../../components/atoms/NoDataFound'

const TagTCModal = ({
  isModalVisible = false,
  onModalClose = () => {},
  onPressOK = () => {},
  options = [],
  searchValue,
  onSearch,
  loadingTc = false,
  selectedTC,
  onSelectTC,
  btnDisable = false,
  sectionCode
}) => {
  const style = {
    display: isModalVisible ? 'block' : 'none'
  }

  const handleSubmit = () => {
    const confirmation = window.confirm(
      `By tagging this installation to TC number ${selectedTC?.number ?? '-'}, you will be changing the reading day of this installation to ${selectedTC?.readingDay ?? '-'}.Are you sure you want to do this?`
    )
    if (confirmation) {
      onPressOK()
    }
  }

  return (
    <>
      <div
        className='modal export-excel-modal'
        id='exampleModal'
        tabindex='-1'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
        style={style}
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h6
                className='modal-title'
                id='exampleModalLabel'
              >
                Tag / Re-tag TC  (Section code - {sectionCode})
              </h6>
              <button
                onClick={onModalClose}
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              />
            </div>
            <div
              className='modal-body'
              style={{ maxHeight: '70vh', overflow: 'auto' }}
            >
              <div className='search-space' style={{ marginBottom: 20 }}>
                <input
                  autoFocus
                  type='text'
                  value={searchValue}
                  onChange={(searchTerm) => onSearch(searchTerm.target.value)}
                  placeholder='Search by TC Number'
                  className='form-control search'
                  style={{ maxWidth: '100%' }}
                />
              </div>
              {loadingTc
                ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <NoDataFound loading />
                  </div>
                  )
                : (
                  <>
                    {options.length === 0 && (
                      <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <NoDataFound message='No Data Found!' />
                      </div>
                    )}
                    {options.map((option, index) => {
                      return (
                        <div className='form-check' key={option.number}>
                          <input
                            style={{ cursor: 'pointer' }}
                            className='form-check-input'
                            value={selectedTC.number}
                            onChange={() => onSelectTC(option)}
                          // checked={selectedTC.hasOwnProperty('transformer') ? selectedTC.transformer.number === option.number : selectedTC.number === option.number}
                            checked={option.number === selectedTC.number}
                            type='radio'
                            name='flexRadioDefault'
                            id='flexRadioDefault1'
                          />
                          <label
                            className='form-check-label'
                            style={{ cursor: 'pointer' }}
                            htmlFor='flexRadioDefault2'
                            onClick={() => onSelectTC(option)}
                          >
                            {`${option.number}, ${option.name}`}
                          </label>
                        </div>
                      )
                    })}
                  </>
                  )}
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                onClick={onModalClose}
              >
                Close
              </button>
              <button
                type='button'
                className='btn btn-primary'
                disabled={!(selectedTC?.number && !btnDisable)}
                onClick={handleSubmit}
              >
                OK
                {btnDisable && <span className='spinner-grow spinner-grow-sm' role='status' aria-hidden='true' style={{ marginLeft: 3 }} />}
              </button>
            </div>
          </div>
        </div>
      </div>
      {isModalVisible && <div className='modal-backdrop fade show' />}
    </>
  )
}

export default TagTCModal
